<template>
  <div class="tableauDeBord">
    <BasicIcon
      name="tableauDeBord"
      class="tableauDeBord--background"
    />
    <div class="tableauDeBord--label">
      <BasicText
        size="h5"
        color="white"
      >
        Tableau de bord
      </BasicText>
    </div>
    <div
      class="document-card--container hide-scrollbar"
      ref="containerRef"
      @scroll="onScroll"
      @mouseenter="pauseAutoScroll"
    >
      <DocumentCard
        v-for="(card, docKey, i) in authorizedDocumentCards"
        :key="docKey"
        :id="makeId(i)"
        :type="docKey"
        :permissions="card!.permissions"
        :indicateurs="card!.indicateurs"
        @ajout-document="ajoutDocument(docKey)"
        @redirection-document="redirectionDocument(docKey, $event)"
        @retry-fetch="fetchIndicator(docKey, $event)"
      />
    </div>
    <div
      class="dots"
      v-if="showDots"
    >
      <a
        v-for="page in pageCount"
        :key="page"
        :class="['dot', { active: (page - 1) === currentPage }]"
        @click="scrollToPage(page - 1)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { useIndicateurTdbStore } from './useIndicateurTdbStore'
  import DocumentCard from '../documentCard/DocumentCard.vue'
  import { useIndicateurTdbScroll } from './useIndicateurTdbScroll'

  const store = useIndicateurTdbStore()
  const { authorizedDocumentCards } = storeToRefs(store)
  const { ajoutDocument, redirectionDocument, fetchIndicator } = store

  const { containerRef, currentPage, pageCount, showDots, pauseAutoScroll, onScroll, scrollToPage, makeId } =
    useIndicateurTdbScroll()
</script>

<style scoped lang="less">
  @import './IndicateurTdb.less';
</style>
